import React, { useContext, useState } from "react";
import '../../css/templates.css';
import FastEdit from './fastEdit';
import AddTemplate from './addTemplate';
import DetailedEdit from './detailedEdit';
import Icon from "../../assets/icons/icon";
import LeadTypeScriptTemplate from "./leadTypeScriptTemplate";
import UnderlineButton from "../../utilities/helperComponents/UnderlineButton";
import { useSelector } from "react-redux";
import { AgentContext } from "../../context/AgentContext";


function Script({ data,formatDate }) {
    const [editingTemplate, setEditTemplate] = useState(false);
    const [addScript, setAddScript] = useState(false);
    const [addLeadTypeScript, setLeadTypeAddScript] = useState(false);
    const [transition, setTransition] = useState(false);
    const [editingItemId, setEditingItemId] = useState(null);
    const [newTemplate, setNewTemplate] = useState(null);
   // const agentId=appInfo[0].agent[0].agentId;

    const toogleAddLeadTypeScript = () => {
        setLeadTypeAddScript(!addLeadTypeScript);
    };

    const addAScript = () => {
        setAddScript(!addScript);
    };
    const editTemplate = (id,name,content, subject) => {
        if(id===false){
            setEditTemplate(false);
        }
        else{
            setEditTemplate({id:id,name:name,content:content, subject:subject});
        }
    };

    const {isB2B} = useContext(AgentContext)

    return (
        <div className={`${isB2B ? 'b2b ' : ''}outerWrapper`}>
                <span className="outerWrapperTitle">
                    <span className="outerWrapperIcon">
                    <span className="fontello" style={{marginTop: '-7px'}}><Icon name={'gratitude-journal'} adjustSize={25} height={34} size={34} className="" adjust="fontello" /></span>
                    </span>
                    Templates
            </span>
            <div
                className="mainBlockOuterWrapper"
                style={{ justifyContent: "space-around" }}
            >
                {addLeadTypeScript ? (
                    <>
                        <div className="here" style={{ 'display': 'inline-flex', 'flexDirection': 'column', 'gap': '8px', alignItems: 'center'}}>
                            <UnderlineButton
                                buttonLabel='Return to Templates'
                                clickHandler={_ => setLeadTypeAddScript(false)}
                                customStyles={{zIndex: 3}}
                            />
                            <LeadTypeScriptTemplate/>
                        </div>
                    </>
                ) :(
                    <>
                        {editingTemplate ? (
                            <DetailedEdit editTemplate={editTemplate} type='Script' editingTemplate={editingTemplate} />
                        ) : (
                            null
                        )}

                        {addScript ? (
                            <AddTemplate addATemplate={addAScript} setNewTemplate={setNewTemplate} type={'Script'} />
                        ) : (
                            null
                        )}
                    </>
                )}
                {!addLeadTypeScript && !editingTemplate && !addScript && (
                    <div className={`frontPageQuilityParentBlockWrapper ${addScript ? 'closeMainBlock' : editingTemplate ? 'closeMainBlock' : ''}`} style={{ width: '75%' }}>
                        <div className="quilityParentBlockHeader">
                            <div className="quilityParentBlockTitle">Scripts</div>
                        </div>
                        <div className="quilityParentBlockContent">
                            {newTemplate == null ? '' : (
                                <div className={`quilityNestedBlockWrapper ${editingItemId === newTemplate.id ? 'focusBigBlock' : ''}`} key={'temp'} style={{ marginTop: '25px' }}>
                                    <div className="quilityCloseWindow oulineQuilityDestructiveButton" >X</div>
                                    <div className="quilityNestedBlockHeader">
                                        <div className="quilityParentBlockTitle">
                                            {newTemplate.name}
                                        </div>
                                    </div>
                                    <div className="infoWrapper">
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Script Name: </span>
                                            {newTemplate.name}
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Content: </span>
                                            <FastEdit
                                                item={newTemplate}
                                                index={'temp'}
                                                transition={transition}
                                                setTransition={setTransition}
                                                editingItemId={editingItemId}
                                                setEditingItemId={setEditingItemId}
                                                type={'Script'}
                                                name={newTemplate.name}
                                                editTemplate={editTemplate}
                                            />
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Date Created: </span>
                                            Just Now
                                        </div>
                                    </div>
                                </div>
                            )}
                            {data[0].type !== false && data[0].map((item, index) => (
                                <div className={`quilityNestedBlockWrapper ${editingItemId === item.id ? 'focusBigBlock' : ''}`} key={`scripts${index}`} style={{marginTop: '25px'}}>
                                    <div className="quilityCloseWindow oulineQuilityDestructiveButton" >X</div>
                                    <div className="quilityNestedBlockHeader">
                                        <div className="quilityParentBlockTitle">
                                            {item.name}
                                        </div>
                                    </div>
                                    <div className="infoWrapper">
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Script Name: </span>
                                            {item.name}
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Content: </span>
                                            <FastEdit
                                                item={item}
                                                index={index}
                                                transition={transition}
                                                setTransition={setTransition}
                                                editingItemId={editingItemId}
                                                setEditingItemId={setEditingItemId}
                                                type={'Script'}
                                                name={item.name}
                                                editTemplate={editTemplate}
                                            />
                                        </div>
                                        <div className="quilityDataLine">
                                            <span className="itemTitle">Date Created: </span>
                                            {formatDate(item.created)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {data[0].type === false && newTemplate != null < 1 && (
                                <div className="title">You have no scripts</div>
                            )}
                        </div>
                        <div className="blockFooter">
                            <div
                                className="buttonWrapper"
                                style={{ marginTop: " 5px", marginLeft: "10px" }}
                            >
                                <div className="dataButtonBlock">Scripts: {data[0].length ? data[0].length : 0}</div>
                                <div className="actionButtonBlock">
                                    <div className={`accentButton ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} onClick={() => toogleAddLeadTypeScript()}>
                                        +  New Lead Type Script
                                    </div>
                                </div>
                                <div className="actionButtonBlock">
                                    <div className={`accentButton ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} onClick={() => addAScript()}>
                                        +  New Script
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                )}

            </div>
        </div>

    );
}

export default Script;

